import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  // Pages that have dark hero backgrounds (use white text)
  const darkHeroPages = ['/'];
  const hasDarkHero = darkHeroPages.includes(location.pathname);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navItems = [
    { label: 'Home', path: '/' },
    { label: 'About', path: '/about' },
    { label: 'Portfolio', path: '/portfolio' },
    { label: 'Services', path: '/services' },
    { label: 'Login', path: '/login' }
  ];

  // Determine if header should use dark text
  const useDarkText = isScrolled || !hasDarkHero;

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''} ${useDarkText && !isScrolled ? 'dark-text' : ''}`}>
      <div className="header-container">
        <Link to="/" className="logo">
          <img 
            src={useDarkText ? "/vesta-logo.png" : "/vesta-logo-white.png"}
            alt="Vesta Designs" 
            className="logo-img"
          />
        </Link>

        <nav className="main-nav">
          <ul className="nav-list">
            {navItems.map((item) => (
              <li key={item.label} className="nav-item">
                <Link to={item.path} className="nav-link">
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
          <Link to="/contact" className="header-cta">Let's talk</Link>
        </nav>

        <button 
          className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div 
            className="mobile-menu"
            initial={{ opacity: 0, x: '100%' }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: '100%' }}
            transition={{ duration: 0.3 }}
          >
            <nav className="mobile-nav">
              {navItems.map((item) => (
                <Link key={item.label} to={item.path} className="mobile-nav-link">
                  {item.label}
                </Link>
              ))}
              <Link to="/contact" className="mobile-nav-link cta">Let's talk</Link>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;
